const SearcherTypes = {
	REFRESH: 'refresh',
	LOOKUP: 'lookup'
};

export default SearcherTypes
